import { NaniumObject, Type } from "nanium/objects";

export class OpeningHoursOpeningType extends NaniumObject<OpeningHoursOpeningType> {
  @Type(String) from?: string;
  @Type(String) to?: string;
}
